import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const Root = styled.p `
  &[data-variant='h3'] {
    font-size: var(--typography-h3-font-size);
    line-height: var(--typography-h3-line-height);
    font-weight: var(--typography-h3-font-weight);
  }

  &[data-variant='h4'] {
    font-size: var(--typography-h4-font-size);
    line-height: var(--typography-h4-line-height);
    font-weight: var(--typography-h4-font-weight);
  }

  &[data-variant='body1-regular'] {
    font-size: var(--typography-body-1-regular-font-size);
    line-height: var(--typography-body-1-regular-line-height);
    font-weight: var(--typography-body-1-regular-font-weight);
  }

  &[data-variant='body1-medium'] {
    font-size: var(--typography-body-1-medium-font-size);
    line-height: var(--typography-body-1-medium-line-height);
    font-weight: var(--typography-body-1-medium-font-weight);
  }

  &[data-variant='body1-semi-bold'] {
    font-size: var(--typography-body-1-semi-bold-font-size);
    line-height: var(--typography-body-1-semi-bold-line-height);
    font-weight: var(--typography-body-1-semi-bold-font-weight);
  }

  &[data-variant='body1-bold'] {
    font-size: var(--typography-body-1-bold-font-size);
    line-height: var(--typography-body-1-bold-line-height);
    font-weight: var(--typography-body-1-bold-font-weight);
  }

  &[data-variant='body2-regular'] {
    font-size: var(--typography-body-2-regular-font-size);
    line-height: var(--typography-body-2-regular-line-height);
    font-weight: var(--typography-body-2-regular-font-weight);
  }

  &[data-variant='body2-medium'] {
    font-size: var(--typography-body-2-medium-font-size);
    line-height: var(--typography-body-2-medium-line-height);
    font-weight: var(--typography-body-2-medium-font-weight);
  }

  &[data-variant='body2-semi-bold'] {
    font-size: var(--typography-body-2-semi-bold-font-size);
    line-height: var(--typography-body-2-semi-bold-line-height);
    font-weight: var(--typography-body-2-semi-bold-font-weight);
  }

  &[data-variant='body2-bold'] {
    font-size: var(--typography-body-2-bold-font-size);
    line-height: var(--typography-body-2-bold-line-height);
    font-weight: var(--typography-body-2-bold-font-weight);
  }

  &[data-variant='body3-regular'] {
    font-size: var(--typography-body-3-regular-font-size);
    line-height: var(--typography-body-3-regular-line-height);
    font-weight: var(--typography-body-3-regular-font-weight);
  }

  &[data-variant='body3-medium'] {
    font-size: var(--typography-body-3-medium-font-size);
    line-height: var(--typography-body-3-medium-line-height);
    font-weight: var(--typography-body-3-medium-font-weight);
  }

  &[data-variant='body3-bold'] {
    font-size: var(--typography-body-3-bold-font-size);
    line-height: var(--typography-body-3-bold-line-height);
    font-weight: var(--typography-body-3-bold-font-weight);
  }

  &[data-variant='body4-regular'] {
    font-size: var(--typography-body-4-regular-font-size);
    line-height: var(--typography-body-4-regular-line-height);
    font-weight: var(--typography-body-4-regular-font-weight);
  }

  &[data-variant='body4-medium'] {
    font-size: var(--typography-body-4-medium-font-size);
    line-height: var(--typography-body-4-medium-line-height);
    font-weight: var(--typography-body-4-medium-font-weight);
  }

  &[data-variant='body4-semi-bold'] {
    font-size: var(--typography-body-4-semi-bold-font-size);
    line-height: var(--typography-body-4-semi-bold-line-height);
    font-weight: var(--typography-body-4-semi-bold-font-weight);
  }

  &[data-variant='body4-bold'] {
    font-size: var(--typography-body-4-bold-font-size);
    line-height: var(--typography-body-4-bold-line-height);
    font-weight: var(--typography-body-4-bold-font-weight);
  }

  &[data-variant='body5-regular'] {
    font-size: var(--typography-body-5-regular-font-size);
    line-height: var(--typography-body-5-regular-line-height);
    font-weight: var(--typography-body-5-regular-font-weight);
  }

  &[data-variant='body5-medium'] {
    font-size: var(--typography-body-5-medium-font-size);
    line-height: var(--typography-body-5-medium-line-height);
    font-weight: var(--typography-body-5-medium-font-weight);
  }

  &[data-variant='body5-semi-bold'] {
    font-size: var(--typography-body-5-semi-bold-font-size);
    line-height: var(--typography-body-5-semi-bold-line-height);
    font-weight: var(--typography-body-5-semi-bold-font-weight);
  }

  &[data-variant='body5-bold'] {
    font-size: var(--typography-body-5-bold-font-size);
    line-height: var(--typography-body-5-bold-line-height);
    font-weight: var(--typography-body-5-bold-font-weight);
  }

  &[data-variant='description-medium'] {
    font-size: var(--typography-description-medium-font-size);
    line-height: var(--typography-description-medium-line-height);
    font-weight: var(--typography-description-medium-font-weight);
  }

  &[data-variant='description-semi-bold'] {
    font-size: var(--typography-description-semi-bold-font-size);
    line-height: var(--typography-description-semi-bold-line-height);
    font-weight: var(--typography-description-semi-bold-font-weight);
  }

  &[data-variant='description-bold'] {
    font-size: var(--typography-description-bold-font-size);
    line-height: var(--typography-description-bold-line-height);
    font-weight: var(--typography-description-bold-font-weight);
  }

  &[data-variant='mobile-30-semi-bold'] {
    font-size: var(--typography-mobile-30-semi-bold-font-size);
    line-height: var(--typography-mobile-30-semi-bold-line-height);
    font-weight: var(--typography-mobile-30-semi-bold-font-weight);
  }

  &[data-variant='mobile-24-bold'] {
    font-size: var(--typography-mobile-24-bold-font-size);
    line-height: var(--typography-mobile-24-bold-line-height);
    font-weight: var(--typography-mobile-24-bold-font-weight);
  }

  &[data-variant='mobile-18-bold'] {
    font-size: var(--typography-mobile-18-bold-font-size);
    line-height: var(--typography-mobile-18-bold-line-height);
    font-weight: var(--typography-mobile-18-bold-font-weight);
  }

  &[data-variant='mobile-16-bold'] {
    font-size: var(--typography-mobile-16-bold-font-size);
    line-height: var(--typography-mobile-16-bold-line-height);
    font-weight: var(--typography-mobile-16-bold-font-weight);
  }

  &[data-variant='mobile-16-semi-bold'] {
    font-size: var(--typography-mobile-16-semi-bold-font-size);
    line-height: var(--typography-mobile-16-semi-bold-line-height);
    font-weight: var(--typography-mobile-16-semi-bold-font-weight);
  }

  &[data-variant='mobile-14-semi-bold'] {
    font-size: var(--typography-mobile-14-semi-bold-font-size);
    line-height: var(--typography-mobile-14-semi-bold-line-height);
    font-weight: var(--typography-mobile-14-semi-bold-font-weight);
  }

  &[data-variant='mobile-14-regular'] {
    font-size: var(--typography-mobile-14-regular-font-size);
    line-height: var(--typography-mobile-14-regular-line-height);
    font-weight: var(--typography-mobile-14-regular-font-weight);
  }

  &[data-variant='mobile-13-semi-bold'] {
    font-size: var(--typography-mobile-13-semi-bold-font-size);
    line-height: var(--typography-mobile-13-semi-bold-line-height);
    font-weight: var(--typography-mobile-13-semi-bold-font-weight);
  }

  &[data-variant='mobile-13-medium'] {
    font-size: var(--typography-mobile-13-medium-font-size);
    line-height: var(--typography-mobile-13-medium-line-height);
    font-weight: var(--typography-mobile-13-medium-font-weight);
  }

  &[data-variant='mobile-13-regular'] {
    font-size: var(--typography-mobile-13-regular-font-size);
    line-height: var(--typography-mobile-13-regular-line-height);
    font-weight: var(--typography-mobile-13-regular-font-weight);
  }

  &[data-variant='mobile-12-bold'] {
    font-size: var(--typography-mobile-12-bold-font-size);
    line-height: var(--typography-mobile-12-bold-line-height);
    font-weight: var(--typography-mobile-12-bold-font-weight);
  }

  &[data-variant='mobile-12-semi-bold'] {
    font-size: var(--typography-mobile-12-semi-bold-font-size);
    line-height: var(--typography-mobile-12-semi-bold-line-height);
    font-weight: var(--typography-mobile-12-semi-bold-font-weight);
  }

  &[data-variant='mobile-12-medium'] {
    font-size: var(--typography-mobile-12-medium-font-size);
    line-height: var(--typography-mobile-12-medium-line-height);
    font-weight: var(--typography-mobile-12-medium-font-weight);
  }

  &[data-variant='mobile-12-regular'] {
    font-size: var(--typography-mobile-12-regular-font-size);
    line-height: var(--typography-mobile-12-regular-line-height);
    font-weight: var(--typography-mobile-12-regular-font-weight);
  }

  &[data-variant='mobile-10-regular'] {
    font-size: var(--typography-mobile-10-regular-font-size);
    line-height: var(--typography-mobile-10-regular-line-height);
    font-weight: var(--typography-mobile-10-regular-font-weight);
  }

  ${(props) => props.$ellipsis &&
    css `
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: nowrap;
    `}
`;
export const Typography = ({ 
/**
 * For backwards compatibility
 */
variant = 'body4-medium', children, component, ellipsis, ref, ...props }) => (_jsx(Root, { "data-variant": variant, ref: ref, ...{
        as: component,
    }, "$ellipsis": ellipsis, ...props, children: children }));
//# sourceMappingURL=typography.js.map